<template>
  <PropertiesList
    :advertiser-ids="companyAdvertiserIds"
    list-title="عقارات الشركة"
    :details-query="{ from: 'companyProperty' }"
    :show-create-actions="false"
    :show-stats="false"
  />
</template>

<script>
import PropertiesList from '@/views/properties/list.vue';

export default {
  name: 'CompanyPropertyList',
  components: { PropertiesList },
  data(){
    return {
      companyAdvertiserIds: ['7003799769', '7021968453'],
    };
  },
};
</script>
